import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Search, MousePointerClick, TrendingUp } from 'lucide-react';
import mockupImg from '../assets/images/strategie-mockup.png';
import './Home.css';
import './Strategie.css';

function Strategie() {
    return (
        <div className="strategie-page">
            {/* Hero Section */}
            <section className="strategie-hero">
                <div className="strategie-hero-content">
                    <div className="hp-badge hp-badge-blue">
                        <span className="dot"></span>STRATEGIE
                    </div>
                    <h1 className="hp-h1">
                        Marketingová strategie
                    </h1>
                    <p className="hp-sub" style={{ whiteSpace: 'pre-line' }}>
                        {"Strategie není dokument.\nJe to rozhodnutí, která mění směr firmy."}
                    </p>
                    <div className="hero-cta" style={{ marginTop: '16px' }}>
                        <a href="https://cal.eu/andrea-liskova/30min" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                            Domluvit call
                        </a>
                    </div>
                </div>

                <div className="strategie-hero-boxes">
                    <div className="str-box">
                        <Target size={24} className="color-blue" />
                        <span className="str-box-title">Audit</span>
                    </div>
                    <span className="str-box-arrow">&rarr;</span>
                    <div className="str-box">
                        <Search size={24} className="color-blue" />
                        <span className="str-box-title">Cíle</span>
                    </div>
                    <span className="str-box-arrow">&rarr;</span>
                    <div className="str-box">
                        <MousePointerClick size={24} className="color-blue" />
                        <span className="str-box-title">Plán</span>
                    </div>
                    <span className="str-box-arrow">&rarr;</span>
                    <div className="str-box bg-blue">
                        <TrendingUp size={24} className="color-white" />
                        <span className="str-box-title color-white" style={{ color: '#FFF' }}>Výsledky</span>
                    </div>
                </div>
            </section>

            {/* How it works */}
            <section className="hp-webdev" style={{ backgroundColor: '#FAFAFA' }}>
                <div className="hp-services-header" style={{ alignItems: 'flex-start', textAlign: 'left', marginBottom: '40px' }}>
                    <div className="hp-badge hp-badge-blue">
                        <span className="dot"></span>JAK TO FUNGUJE
                    </div>
                    <h2 className="hp-h2">Čtyři kroky ke strategii, která funguje</h2>
                </div>

                <div className="steps-grid">
                    <div className="step-card">
                        <div className="step-num">01</div>
                        <h3 className="step-title">Kontext a cíle</h3>
                        <p className="step-desc">Nejdřív pochopím váš byznys, trh a cíle.</p>
                    </div>
                    <div className="step-card">
                        <div className="step-num">02</div>
                        <h3 className="step-title">Analýza a příležitosti</h3>
                        <p className="step-desc">Odhalíme, co funguje, co brzdí růst a kde je největší potenciál.</p>
                    </div>
                    <div className="step-card">
                        <div className="step-num">03</div>
                        <h3 className="step-title">Strategická rozhodnutí</h3>
                        <p className="step-desc">Stanovíme positioning, klíčová sdělení a roli jednotlivých kanálů.</p>
                    </div>
                    <div className="step-card">
                        <div className="step-num">04</div>
                        <h3 className="step-title">Roadmapa a měření</h3>
                        <p className="step-desc">Dostanete konkrétní plán krok za krokem včetně KPI a priorit.</p>
                    </div>
                </div>
            </section>

            {/* Output Section */}
            <section className="hp-portfolio" style={{ backgroundColor: '#FFFFFF' }}>
                <div className="str-output-content">
                    <div className="str-output-left">
                        <div className="hp-badge hp-badge-blue">
                            <span className="dot"></span>JAKÝ JE VÝSTUP
                        </div>
                        <h2 className="hp-h2">Strategický dokument a akční plán</h2>
                        <p className="hp-sub-lh" style={{ marginBottom: '16px' }}>
                            Výstupem je strukturovaný strategický dokument a akční plán, který můžete okamžitě realizovat — samostatně nebo s mou podporou.
                        </p>
                        <ul className="hp-sub-list">
                            <li>Titulní strana strategického dokumentu</li>
                            <li>Roadmapa s prioritami a časovým plánem</li>
                            <li>Funnel a KPI dashboard</li>
                        </ul>
                    </div>
                    <div className="str-output-right">
                        <img src={mockupImg} alt="Strategický dokument mockup" className="str-output-img" />
                    </div>
                </div>
            </section>

            {/* Quote / Flex Section */}
            <section className="str-flex-section">
                <p className="str-flex-text">
                    {"Strategii vždy navrhuji podle ambicí projektu —\nať už potřebujete nastavit konkrétní oblast (např. sociální sítě) nebo celkový marketingový směr."}
                </p>
            </section>

            <section className="str-quote-section">
                <div className="str-quote-line"></div>
                <h3 className="str-quote-text">
                    {"I malý projekt může růst rychle —\npokud stojí na správných rozhodnutích."}
                </h3>
                <a href="https://cal.eu/andrea-liskova/30min" target="_blank" rel="noopener noreferrer" className="btn btn-white" style={{ marginTop: '24px' }}>
                    Domluvit strategický call
                </a>
            </section>
        </div>
    );
}

export default Strategie;
